<ng-container *ngIf="show" [ngSwitch]="banner">

   <app-push-activator class="" *ngSwitchCase="'push-activator'"></app-push-activator>

   <div *ngSwitchCase="'ready-to-work'" class="container-fluid shadow-kp vanguard-gradient px-2">
      <a class="container pointer d-flex align-items-center justify-content-between px-0" routerLink="/account/rtw/post"
         [ga-event]="{Category: 'global-banner', Action: 'banner-click', Label: 'ready-to-work'}">
         <div class="flex-fill fs-normal fs-md-xl text-center py-2 f-white">
            با سرویس <b>«آماده‌به‌کار»</b> به جای جستجوی آگهی <br class="d-md-none" />
            <div class="d-none d-md-inline">با فقط {{userService.ReadyToWorkBasePrice|number}} تومن
               توانایی‌هات رو معرفی کن
            </div>
            <div class="btn btn-secondary btn-sm d-md-none"> با فقط {{userService.ReadyToWorkBasePrice|number}} تومن
               توانایی‌هات رو معرفی کن
            </div>
         </div>
         <div class="flex-fill d-none d-lg-block text-left">
            <div class="btn white-bg f-vanguard my-2 fw-bold">
               <img class="ml-2 icon-sm" src="/assets/images/icons/vanguard-seeker-vanguard.svg" alt="کارجوی پیشتاز">
               <span>همین حالا «آماده‌به‌کار»ت رو اعلام کن</span>
            </div>
         </div>
      </a>
   </div>

   <div *ngSwitchCase="'vanguard-seeker'" class="container-fluid shadow-kp vanguard-gradient px-2">
      <a class="container pointer d-flex align-items-center justify-content-between px-0" routerLink="/seeker/karpasha"
         [ga-event]="{Category: 'global-banner', Action: 'banner-click', Label: 'vangaurd-seeker'}">
         <div class="flex-fill d-flex">
            <img src="/assets/images/icons/vanguard-seeker-white-lg.svg" alt="کارجوی پیشتاز"
               style="width: 42px;height: 42px;">
         </div>

         <div class="flex-fill fs-normal fs-md-xl text-center py-2 f-white">
            اکثر شغل‌ها همون چند روز اول پر میشن! <br class="d-md-none" />
            <div class="d-none d-md-inline">با {{userService.vanguardBasePrice|number}} تومن قبل از بقیه باخبر شو
            </div>
            <div class="btn btn-secondary btn-sm d-md-none">با {{userService.vanguardBasePrice|number}} تومن قبل
               از بقیه باخبر شو</div>
         </div>
         <div class="flex-fill d-none d-lg-block text-left">
            <div class="btn white-bg f-vanguard my-2 fw-bold">
               <img class="ml-2 icon-sm" src="/assets/images/icons/vanguard-seeker-vanguard.svg" alt="کارجوی پیشتاز">
               <span>همین حالا کارجوی پیشتاز شو</span>
            </div>
         </div>
      </a>
   </div>

   <div *ngSwitchCase="'seeker-resume'" class="container-fluid shadow-kp x-dark-blue-bg px-2">
      <a class="container pointer d-flex align-items-center justify-content-between px-0" routerLink="/seeker/karpasha"
         [ga-event]="{Category: 'global-banner', Action: 'banner-click', Label: 'seeker-resume'}">
         <div class="flex-fill fs-normal fs-md-xl text-center py-2 f-white">
            جستجو نکن! به جاش بگو کی هستی<br class="d-md-none" />
            <div class="d-none d-md-inline">. بذار کارپیشه<i class="fa fa-robot mx-1 f-yellow"></i>برات جستجو کنه</div>
            <div class="btn btn-secondary btn-sm d-md-none yellow-bg">
               بذار کارپیشه<i class="fa fa-robot mx-1 f-x-dark-blue"></i>برات جستجو کنه
            </div>
         </div>
         <div class="flex-fill d-none d-lg-block text-left">
            <div class="btn white-bg f-x-dark-blue my-2 fw-bold">
               <span>ثبت اطلاعات</span>
            </div>
         </div>
      </a>
   </div>

   <!-- <div *ngSwitchCase="'register-agent'" class="container-fluid shadow-kp x-dark-blue-bg px-2">
      <a class="container pointer d-flex align-items-center justify-content-between px-0" routerLink="/seeker/karpasha">
         <div class="flex-fill fs-normal fs-md-xl text-center py-2 f-white">
            جستجو نکن! به جاش بگو کی هستی<br class="d-md-none" />
            <div class="d-none d-md-inline">. بذار کارپیشه<i class="fa fa-robot mx-1 f-yellow"></i>برات جستجو کنه</div>
            <div class="btn btn-secondary btn-sm d-md-none yellow-bg">
               بذار کارپیشه<i class="fa fa-robot mx-1 f-x-dark-blue"></i>برات جستجو کنه
            </div>
         </div>
         <div class="flex-fill d-none d-lg-block text-left">
            <div class="btn white-bg f-x-dark-blue my-2 fw-bold">
               <span>ثبت اطلاعات</span>
            </div>
         </div>
      </a>
   </div> -->
</ng-container>